import { useMutation } from '@connectrpc/connect-query'
import { importCisContracts } from '@ebalance/proto/bffuser/v1/cis_contract_service-CisContractService_connectquery'

import { type InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * CIS契約マスタ CSV 取込 mutation フック (プレビュー / 確定共通、dry_run で分岐。
 * `useImportSupply48Data` と同判断)。
 *
 * 本画面 (`pages/CisContractCsvUpload`) からのみ使う page-local hook
 * (frontend/apps/ebalance/CLAUDE.md「hook は page-local が default」)。
 * CIS契約マスタを表示する list 画面は本 PR のスコープ外のため、
 * cache invalidation は行わない (画面がまだ存在しない)。
 */
export function useImportCisContracts(): InvalidatingMutationResultFor<
  typeof importCisContracts
> {
  return useMutation(importCisContracts)
}
